let transactions = [];
const observableTransactions = new Rx.BehaviorSubject(transactions);

/**
 * @ngdoc service
 * @name repositories.TransactionsRepository
 *
 * @description
 * TransactionsRepository.
 */
const TransactionsRepository = {

    replace(data) {

        transactions = data;
        observableTransactions.onNext(transactions);

    },

    getAll() {

        return transactions;

    },

    /**
     * Return true if the purchase type is voucher
     * @param activationCodeId activation code id
     */
    isVoucherPurchase(activationCodeId) {

        const transactionWithVoucher = transactions
            .find(transaction => transaction.attributes.activation_code === activationCodeId);

        if (transactionWithVoucher && transactionWithVoucher.attributes) {

            return transactionWithVoucher.attributes.payment_type === 'Voucher';

        }

        return false;

    },

    getObservable() {

        return observableTransactions;

    },

    /**
     * Return the transaction details for a given id.
     * @param transactionId The transaction id
     */
    getById(transactionId) {

        return transactions
            .find(transaction => (String(transaction.id) === String(transactionId)));

    },

};

export default TransactionsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.transactionsRepository.js